module.exports = __webpack_public_path__ + "images/emoji/tomato.4d7a101ff9ea65921488.png";